export default function Solutions() {
  const solutions = [
    {
      icon: 'ri-customer-service-2-line',
      title: 'Proactive Managed IT Support',
      features: [
        'Unlimited helpdesk & onsite support',
        'Proactive monitoring & maintenance',
        'Fast response times tailored for legal environments',
        'Multi-office and remote attorney support'
      ]
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Cybersecurity Built for Law Firms',
      features: [
        'Advanced email security & phishing protection',
        'Multi-factor authentication (MFA)',
        'Endpoint detection & response (EDR)',
        'Secure backups & ransomware protection',
        'Network security & penetration testing'
      ]
    },
    {
      icon: 'ri-file-shield-2-line',
      title: 'Compliance & Risk Management',
      features: [
        'Alignment with ABA and state bar expectations',
        'Data protection & encryption strategies',
        'Access controls and audit readiness',
        'Security awareness training for staff'
      ]
    },
    {
      icon: 'ri-folder-lock-line',
      title: 'Document & Case System Optimization',
      features: [
        'Secure document storage & sharing',
        'Performance tuning for large legal files',
        'Version control and access tracking',
        'Integration with legal software platforms'
      ]
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Strategic IT Leadership (vCIO)',
      features: [
        'IT budgeting and cost forecasting',
        'Technology roadmaps aligned to firm growth',
        'Vendor and software management',
        'Executive-level reporting and risk visibility'
      ]
    }
  ];

  return (
    <section id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <i className="ri-lightbulb-line text-[#e10708] text-xl mr-2 w-5 h-5 flex items-center justify-center"></i>
            <span className="text-[#e10708] text-sm uppercase tracking-widest font-light">Our Approach</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-serif text-[#1A1F2E] leading-tight mb-6">
            How We Support Law Firms
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Comprehensive IT and cybersecurity solutions designed specifically for the legal industry.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#FAF9F6] to-white rounded-2xl p-8 border border-gray-200 hover:border-[#e10708] transition-all duration-300 hover:shadow-xl hover:shadow-[#e10708]/10"
            >
              <div className="w-16 h-16 bg-[#e10708]/10 rounded-xl flex items-center justify-center mb-6">
                <i className={`${solution.icon} text-[#e10708] text-3xl w-8 h-8 flex items-center justify-center`}></i>
              </div>

              <h3 className="text-2xl font-bold text-[#1A1F2E] mb-6">
                {solution.title}
              </h3>

              <ul className="space-y-3">
                {solution.features.map((feature, idx) => (
                  <li
                    key={idx}
                    className="flex items-start text-base text-gray-700"
                  >
                    <i className="ri-check-line text-[#e10708] mr-3 mt-1 flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
